<template>
    <RealtimeSystem
        :key="renderCount"
        :componentKey="componentKey"
        :onAnyEventsSocketScheme="onAnyEventsSocketScheme"
        @failedConnect="failedConnect"
        @endMatch="endMatch"
        @endDownload="endDownload"
    />
</template>

<script>
import RealtimeSystem from '../../MapV2/RealtimeSystem/RealtimeSystem.vue';
export default {
    name: 'ReconciliationImportRealtimeSystem',
    components: {RealtimeSystem},
    data: () => ({
        componentKey: 'ReconciliationImportRealtimeSystem',
        onAnyEventsSocketScheme: [
			{
				id: 'endMatch',
				eventNameSocket: 'match_queue_job',
				emitNameComponent: 'endMatch',
			},
            {
                id: 'endDownload',
                eventNameSocket: 'match_to_pre_fact_job',
                emitNameComponent: 'endDownload',
            }
		],
        renderCount: 0
    }),
    methods: {
        failedConnect() {
            console.log('failedConnect');
            this.renderCount += 1;
        },
        endMatch(data) {
            const {success = false} = data;
            
            this.$emit('endMatch', Boolean(success));
        },
        endDownload(data) {
            const {success = false} = data;

            this.$emit('endDownload', Boolean(success));
        }
    }
}
</script>